import React, { useEffect, useState } from 'react';
import { Box, Typography, TextField, Button, Paper, ToggleButton, ToggleButtonGroup, Grid, duration, CircularProgress } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../controller/api';
import logo from '../assets/images/aiforhrhub.png';
import { memberships } from '../data/membershipTypes';
import { Check } from '@mui/icons-material';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

const stripePromise = loadStripe('pk_live_51QBHipA8XwBIdmYf3FWwuUluzpjmo15S3m4YWO2RsKyYxEezAllP9b2B7pML8taK18nfT86q0lgqa4Ah3vyPoFIO00kr7TRsjA');

const RegisterForm = () => {
const [firstName, setFirstName] = useState('');
const [lastName, setLastName] = useState('');
const [email, setEmail] = useState('');
const [password, setPassword] = useState('');
const [confirmPassword, setConfirmPassword] = useState('');
const [couponCode, setCouponCode] = useState('');
const [coupon, setCoupon] = useState('');
const [couponStatus, setCouponStatus] = useState(null);
const [showPayment, setShowPayment] = useState(true);
const [stripePaymentConfirmed, setStripePaymentConfirmed] = useState(false);
const [plan, setPlan] = useState('monthly');
const [discount, setDiscount] = useState(0);  // Track discount percentage
const [disablePlan, setDisablePlan] = useState(false)
const [subscription, setSubscription] = useState(plan === 'monthly'? memberships[1]: memberships[2])
const navigate = useNavigate();
const stripe = useStripe();
const elements = useElements();
const [isLoading, setIsLoading] = useState(false); // Loading state
const location = useLocation();
const [paramA, setParamA] = useState(null);

useEffect(() => {
    // Parse the query string and get the 'a' parameter
    const params = new URLSearchParams(location.search);
    const param = params.get('a');
    
    // If the 'a' parameter exists, update the state
    if (param) {
        setPlan(param);
    } 
}, [location]); // Dependency array to re-run effect on location change


// Original prices
const monthlyBasePrice = 99;
const annualBasePrice = 999;

// Discounted prices based on discount percentage
const monthlyPrice = monthlyBasePrice * (1 - discount / 100);
const annualPrice = annualBasePrice * (1 - discount / 100);

const handleCouponChange = async (e) => {
  const code = e.target.value;
  setCouponCode(code);
  
  // Reset disablePlan when code is cleared or invalid
  if (code.length === 0) {
    setCouponStatus(null);
    setShowPayment(true);
    setDiscount(0);
    setDisablePlan(false); // Allow plan change if coupon is cleared
    return; // Exit early
  }

if(code ==='HUB747' || code ==='HUB997'){
  setCouponStatus(null);
    setShowPayment(true);
    setDiscount(0);
    setDisablePlan(false); // Allow plan change if coupon is cleared
    setCouponStatus(<Typography>Go <a href="https://hub.aiforhrhub.com/#/deep-dive-training-offer">here</a> to register for this offer.</Typography>);
    return;
}
  
  if (code.length > 2) {
    try {
      const response = await axios.post(`${API}/auth/validate-coupon`, { code });
      if (response.data.valid) {
        let membership = memberships.find((i) => i.id === response.data.offer.type);
        console.log(response.data.offer.discount)
        // Check if the membership is enabled
        if (!membership.enabled) {
          setCouponStatus('This offer is no longer active.');
          setShowPayment(true);
          setDiscount(0); // Reset discount
          setDisablePlan(false); // Allow plan change if offer is inactive
          return; // Exit early
        }

        // Automatically set the plan based on the coupon's valid durations
        if (membership.duration.includes('monthly') && membership.duration.includes('annual')) {
          setPlan(plan); // Keep the current plan if both are allowed
        } else if (membership.duration.includes('monthly')) {
          setPlan('monthly'); // Set to monthly if only monthly is allowed
          setDisablePlan(true);
        } else if (membership.duration.includes('annual')) {
          setPlan('annual'); // Set to annual if only annual is allowed
          setDisablePlan(true);
        }
        setCoupon(membership)
        setDiscount( response.data.offer.discount); // Set discount percentage
        setCouponStatus(<Typography color='green'><Check />{membership.title} {response.data.offer.discount !== '100' ?`${response.data.offer.discount} % off` : ''}</Typography>);
        setShowPayment(response.data.offer.discount < 100); // Skip payment if discount is 100%
      } else {
        setCouponStatus('Invalid code');
        setShowPayment(true);
        setDiscount(0); // Reset discount
        setDisablePlan(false); // Allow plan change if coupon is invalid
      }
    } catch (error) {
      console.error('Coupon validation failed:', error.response.data.message);
      setCouponStatus(error.response.data.message);
      setShowPayment(true);
      setDiscount(0);
      setDisablePlan(false); // Allow plan change if there's an error
    }
  }
};




const handleRegister = async () => {
  setIsLoading(true)
  if (!firstName || !lastName || !email || !password || !confirmPassword) {
    alert('Please fill in all required fields.');
    return;
  }
  if (password !== confirmPassword) {
    alert('Passwords do not match.');
    return;
  }

  let customerId = 'NA';
  let paymentId = 'NA';
  let paymentMethodId = 'NA'; // To store the payment method ID

  // Proceed if payment is required
  if (showPayment) {
    if (!stripe || !elements) return;
    const cardElement = elements.getElement(CardElement);

    try {
      
      // First, fetch the client secret from the backend
      const response = await axios.post(`${API}/subscription/create-payment-intent`, {
        amount: plan === 'annual' ? Math.round(annualPrice)* 100 : Math.round(monthlyPrice) * 100,
        currency: 'usd',
        email,
        firstName,
        lastName
      });
      console.log(response.data);
      const clientSecret = response.data.clientSecret;
      customerId = response.data.customer;
      
      // Confirm the payment using the fetched client secret
      const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: cardElement,
          billing_details: {
            name: `${firstName} ${lastName}`,
            email,
          },
        },
      });

      if (error) {
        console.error('Payment failed:', error.message);
        alert(error.message);
        setIsLoading(false)

        return;
      } else if (paymentIntent && paymentIntent.status === 'succeeded') {
      
        
        // Get the payment method ID from the payment intent
        paymentMethodId = paymentIntent.payment_method;
        
        // Set the payment method as the default for the customer
        const { data } = await axios.post(`${API}/subscription/update-customer-payment`, {
          customerId: customerId,
          paymentMethodId: paymentIntent.payment_method,
        });
        // Save the payment ID and customer ID for later use
        if (data.success) {
          paymentId = paymentIntent.id;
        } else {
          alert('Failed to update payment method');
          setIsLoading(false)

          return;
        }
      }
    } catch (error) {
      console.error('Error processing payment:', error);
      alert(error.response.data.error);
      setIsLoading(false)

      return;
    }
  }

  // After payment (or if no payment required), register the user
  const renewalDate = new Date();
  renewalDate.setMonth(renewalDate.getMonth() + (coupon.training ? coupon.ends : plan === 'monthly' ? 1 : 12));

  const rate = {
    type: discount === 100 ? 'free' : discount > 0 ? 'discounted' : 'standard',
    discount,
    renewalRate: coupon.renewalRate? coupon.renewalRate * 100 : plan === 'annual' ? coupon.renewAtDiscountedRate ? annualPrice * 100 : annualBasePrice * 100 : coupon.renewAtDiscountedRate ? monthlyPrice * 100 : monthlyBasePrice * 100,
    frequency: plan
  };

console.log(rate)

  const userData = {
    firstName,
    lastName,
    email,
    password,
    paymentInformation: {
      customerId,
      paymentId,
    },
    rate,
    subscription: {
      subscription: subscription.id,
      isActive: true,
      renewalDate: renewalDate,
      startDate: new Date(),
      training: coupon.training,
      isCanceled:false
    }
  };
  console.log(userData);

  try {
    const response = await axios.post(`${API}/auth/register-pls`, 
      { userData, 
        price: plan === 'annual' ? Math.round(annualPrice)* 100 : Math.round(monthlyPrice) * 100,
        code: couponCode 
      });
    if (response.status === 201) {
      alert('Registration Successful');
      setIsLoading(false)

      window.location.href = 'https://app.aiforbusinesshub.pro'
    } else {
      alert(`Registration failed: ${response.data.error || 'Unknown error'}`);
    }
  } catch (error) {
    setIsLoading(false)

    console.error('Registration failed:', error);
    alert(`Registration failed: ${error.response?.data.error || error.message}`);
  }
};


return (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#074B79', backgroundImage: 'url("https://www.transparenttextures.com/patterns/always-grey.png")', backgroundSize: 'repeat', padding: 3 }}>
    <Paper elevation={4} sx={{ textAlign: 'center', p: 4, maxWidth: 600, width: '100%', borderRadius: 2 }}>
      <img src={logo} alt="Logo" style={{ marginBottom: '1rem', width: 200 }} />
      <Typography variant="h5" align="center" gutterBottom><b>REGISTER</b></Typography>
       <Box sx={{ textAlign: 'start' }}>
          <Typography sx={{ fontSize: 16 }} variant="button" gutterBottom><b>User Information</b></Typography>
        </Box>
        <Grid spacing={2} container>
          <Grid item xs={12} sm={6}>
          <TextField label="First Name" variant="outlined" fullWidth margin="normal" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
          </Grid>
          <Grid item xs={12} sm={6}> 
          <TextField label="Last Name" variant="outlined" fullWidth margin="normal" value={lastName} onChange={(e) => setLastName(e.target.value)} />
          </Grid>
        </Grid>
        
        <TextField label="Email" variant="outlined" fullWidth margin="normal" value={email} onChange={(e) => setEmail(e.target.value)} />
        <Grid spacing={2} container>
        <Grid item xs={12} sm={6}>
        <TextField label="Password" variant="outlined" type="password" fullWidth margin="normal" value={password} onChange={(e) => setPassword(e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={6}>
        <TextField label="Confirm Password" variant="outlined" type="password" fullWidth margin="normal" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
        </Grid>
        </Grid>
        {/* Coupon Field */}
        <TextField label="Coupon Code" variant="outlined" fullWidth margin="normal" value={couponCode} onChange={handleCouponChange} helperText={couponStatus} />

   
        {/* Payment Form */}
        {showPayment && (
          <>
               {/* Plan Toggle */}
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <ToggleButtonGroup
          disabled={disablePlan}
            value={plan}
            exclusive
            onChange={(e, newPlan) => setPlan(newPlan)}
            color="primary"
          >
            <ToggleButton value="monthly">Monthly</ToggleButton>
            <ToggleButton value="annual">Annual</ToggleButton>
          </ToggleButtonGroup>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
            ${plan === 'annual' ? Math.round(annualPrice) : Math.round(monthlyPrice) }
          </Typography>
        </Box>

      
          <Box sx={{ textAlign: 'start', mb: 2, mt:4 }}>
            <form>
              <CardElement options={{ style: { base: { fontSize: '16px', color: '#424770' } } }} />
              <br/>
            </form>
          </Box>
          </>
        )}

        {/* Register Button */}
        <Button 
          variant="contained" 
          fullWidth 
          sx={{ mt: 3, py: 1.5, fontSize: '1rem' }} 
          onClick={handleRegister}
        >
           {isLoading ? (
              <CircularProgress size={24} style={{ color: 'white' }} /> // Spinner
            ) : (
              'Register'
            )}
        </Button> </Paper>
    </Box>
  );
};

const Register = () => (
  <Elements stripe={stripePromise}>
    <RegisterForm />
  </Elements>
);

export default Register;
